module.exports={
  "Description": "VE : NNNN, NNNN-A",
  "RedundantCharacters": " -",
  "ValidationRegex": "^[0-9]{4}[a-zA-Z]?$",
  "TestData": {
    "Valid": [
      "1234",
      "1234-A"
    ],
    "Invalid": [
      "123",
      "1234AA"
    ]
  }
}